import styled from 'styled-components'

export const Header = styled.section`
  float: left;
  width: 100%;
  position: relative;
  padding: 15px 15px 20px 0;
`

// Box Conteúdo
export const TextoHeader = styled.span`
  float: left;
  width: 100%;
  text-align: center;
  color: #fff;
  font-size: 22px;
  font-weight: bold;
  line-height: 34px;

  strong {
    color: #00B9FF;
  }
`
